// Utility to get human readable time difference from a date string
export function getTimeAgo(dateString) {
  if (!dateString) return '';
  const now = new Date();
  const updated = new Date(dateString);
  const diffMs = now - updated;
  const diffSec = Math.floor(diffMs / 1000);
  if (diffSec < 60) return `${diffSec} seconds ago`;
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin} minutes ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr} hours ago`;
  const diffDay = Math.floor(diffHr / 24);
  if (diffDay < 30) {
    if (diffDay === 1) return '1 day ago';
    return `${diffDay} days ago`;
  }
  const diffMonth = Math.floor(diffDay / 30);
  if (diffMonth < 12) return `${diffMonth} months ago`;
  const diffYear = Math.floor(diffMonth / 12);
  return `${diffYear} years ago`;
}
